import React from 'react';

// Image + Text Section (side by side)
const ImageTextSection = ({ data }) => {
  const { 
    heading, 
    content, 
    image, 
    image_position = 'left',
    background_color,
    cta_label,
    cta_link
  } = data || {};
  
  const bgStyle = background_color ? { backgroundColor: background_color } : {};
  const isImageLeft = image_position === 'left';
  
  return (
    <section className="py-16 px-4" style={bgStyle}>
      <div className="max-w-6xl mx-auto">
        <div className={`flex flex-col ${isImageLeft ? 'md:flex-row' : 'md:flex-row-reverse'} gap-8 items-center`}>
          {/* Image */}
          {image && (
            <div className="w-full md:w-1/2">
              <img 
                src={image} 
                alt={heading || 'Section image'} 
                className="w-full h-auto rounded-xl shadow-lg"
              />
            </div>
          )}
          
          {/* Content */}
          <div className="w-full md:w-1/2">
            {heading && (
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                {heading}
              </h2>
            )}
            {content && (
              <div 
                className="rich-content prose prose-lg max-w-none text-gray-700 mb-6"
                dangerouslySetInnerHTML={{ __html: content }}
              />
            )}
            {cta_label && cta_link && (
              <a 
                href={cta_link}
                className="inline-block bg-black text-white px-6 py-3 rounded-lg font-medium hover:bg-gray-800 transition-colors"
              >
                {cta_label}
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImageTextSection;
